import {
  EmailInputForm,
  InputForm,
  PhoneNumInputForm,
  PhoneNumLanInputForm,
} from "../../components/forms/inputForm";
import addHospitalName from "../../constants/hospitalManagement/addHospital";
import ImageUpload from "../../components/forms/imageUpload";
import AutoCompleteForm from "../../components/forms/autoCompleteForm";
import {
  CountryList,
  DistrictList,
  HobliList,
  StateList,
  TalukList,
} from "./apicalls/locationList";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import enums from "../../constants/enums";
import { isObjectEmpty } from "../../utils/isObject";
import { Box } from "@mui/material";
import { Button } from "../../components/buttons/buttons";
import { AddIcon, DeleteIcons } from "../../components/muiIconsImport";
import { Button as Button2 } from "@mui/material";

const BasicInformation = ({ control, watch, setValue, previousData }: any) => {
  const [visibleFieldsCount, setVisibleFieldsCount] = useState(() => {
    if (previousData?.phoneThree) return 3;
    if (previousData?.phoneTwo) return 2;
    return 1;
  });

  const handleAddField = () => {
    if (visibleFieldsCount < 3) {
      setVisibleFieldsCount((prev) => prev + 1);
    }
  };

  const handleRemoveField = (fieldId: "phoneTwo" | "phoneThree") => {
    // Reset the form value inside React Hook Form when hiding it
    setValue(fieldId, "");
    setVisibleFieldsCount((prev) => prev - 1);
  };

  const location = useLocation();
  const pathAction = location?.state?.action;
  const countryId: number = watch("countryId");
  const stateId: number = watch("stateId");
  const districtId: number = watch("districtId");
  const talukId: number = watch("talukId");
  const cityId: number = watch("cityId");
  const { countryLists, countryError, countryLoading, fetchCountry } =
    CountryList();
  const { stateLists, stateError, stateLoading, fetchState } =
    StateList(countryId);

  const { districtLists, districtError, districtLoading, fetchDistrict } =
    DistrictList(stateId);

  const { talukLists, talukError, talukLoading, fetchTaluk } =
    TalukList(districtId);

  const { hobliLists, hobliError, hobliLoading, fetchHobli } =
    HobliList(talukId);

  useEffect(() => {
    fetchCountry();
  }, []);

  useEffect(() => {
    if (
      countryId ||
      (pathAction === enums.add && isObjectEmpty(previousData))
    ) {
      fetchState();
      fetchDistrict();
      fetchTaluk();
      fetchHobli();
      setValue("Town", "");
      setValue("Pincode", "");
    }
  }, [countryId]);

  useEffect(() => {
    if (stateId || (pathAction === enums.add && isObjectEmpty(previousData))) {
      fetchDistrict();
      fetchTaluk();
      fetchHobli();
    }
  }, [stateId]);

  useEffect(() => {
    if (
      districtId ||
      (pathAction === enums.add && isObjectEmpty(previousData))
    ) {
      fetchTaluk();
      fetchHobli();
    }
  }, [districtId]);
  useEffect(() => {
    if (cityId || (pathAction === enums.add && isObjectEmpty(previousData))) {
      fetchTaluk();
      fetchHobli();
    }
  }, [cityId]);

  useEffect(() => {
    if (talukId || (pathAction === enums.add && isObjectEmpty(previousData))) {
      fetchHobli();
    }
  }, [talukId]);

  const countryChange = () => {
    setValue("stateId", 0);
    setValue("districtId", 0);
    setValue("talukId", 0);
    setValue("hobliId", 0);
    setValue("state", "");
    setValue("district", "");
    setValue("taluk", "");
    setValue("hobli", "");
    setValue("Town", "");
    setValue("Pincode", "");
    fetchState();
    fetchDistrict();
    fetchTaluk();
    fetchHobli();
  };
  const stateChange = () => {
    setValue("districtId", 0);
    setValue("talukId", 0);
    setValue("hobliId", 0);
    setValue("district", "");
    setValue("taluk", "");
    setValue("hobli", "");
    setValue("city", "");
    setValue("pincode", "");
    fetchDistrict();
    fetchTaluk();
    fetchHobli();
  };
  const districtChange = () => {
    setValue("talukId", 0);
    setValue("hobliId", 0);
    setValue("taluk", "");
    setValue("hobli", "");
    setValue("city", "");
    setValue("pincode", "");
    fetchTaluk();
    fetchHobli();
  };
  const talukChange = () => {
    setValue("hobliId", 0);
    setValue("hobli", "");
    setValue("city", "");
    setValue("pincode", "");
    fetchHobli();
  };

  return (
    <>
      <div className="">
        <div className="grid lg:grid-cols-3 gap-6 items-center">
          <div className="col-span-1">
            <InputForm
              label={"Hospital Name*"}
              id="hospitalName"
              control={control}
              defaultValue={previousData?.hospitalName}
              maxLength={50}
            />
          </div>
          <ImageUpload
            name="logoURL"
            setValue={setValue}
            control={control}
            watch={watch}
            image={previousData?.logoURL}
            buttonText="Upload Hospital Logo"
          />
        </div>
        <hr className="my-6" />

        <div>
          <span className="text-16 text-primary font-semibold">
            {addHospitalName.LicenseDetails}
          </span>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-6 my-6">
            <InputForm
              label={"License Number*"}
              type="text"
              id="licenseNumber"
              control={control}
              defaultValue={previousData?.licenseNumber}
              maxLength={50}
            />
            <InputForm
              label={"License Authority*"}
              id="licenseAuthority"
              control={control}
              defaultValue={previousData?.licenseAuthority}
              maxLength={50}
            />
            <InputForm
              label={"HFR ID* (Health Facility Registry)"}
              id="hfrId"
              control={control}
              defaultValue={previousData?.hfrId || '--'}
              maxLength={50}
            />
            <InputForm
              label={"Branch Name"}
              id="branch"
              control={control}
              defaultValue={previousData?.branch || ""}
              maxLength={50}
            />
            <InputForm
              label={"GST Number"}
              id="gst"
              control={control}
              defaultValue={previousData?.gst || ''}
              maxLength={50}
            />
            <InputForm
              label={"PAN Number"}
              id="pan"
              control={control}
              defaultValue={previousData?.pan || ''}
              maxLength={50}
            />
          </div>
        </div>

        <hr className="my-6" />

        <div>
          <span className="text-16 text-primary font-semibold">
            {addHospitalName.Address}
          </span>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-6 my-6">
            <InputForm
              label={"Building Number"}
              id="buildingNumber"
              control={control}
              defaultValue={previousData?.buildingNumber}
              maxLength={50}
              required={false}
            />
            <InputForm
              label={"Street Name*"}
              id="streetName"
              control={control}
              defaultValue={previousData?.streetName}
              maxLength={50}
            />
            <InputForm
              label={"Locality*"}
              id="locality"
              control={control}
              defaultValue={previousData?.locality}
              maxLength={50}
            />
            <div className="hidden w-0 h-0 invisible">
              <InputForm
                label={"Country Id"}
                id="countryId"
                control={control}
                defaultValue={previousData?.countryId}
              />
            </div>
            {countryLoading ? (
              <>
                <AutoCompleteForm
                  label={"Country*"}
                  id={"dummycountry"}
                  options={[]}
                  control={control}
                />
              </>
            ) : (
              <AutoCompleteForm
                label={"Country*"}
                id={"country"}
                options={countryLists ?? []}
                control={control}
                defaultValue={previousData?.country}
                handleChange={(e: any, seletedOption: any) => {
                  setValue("countryId", seletedOption?.value);
                  countryChange();
                }}
              />
            )}

            <div className="hidden w-0 h-0 invisible">
              <InputForm
                label={"State Id"}
                id="stateId"
                control={control}
                defaultValue={previousData?.stateId}
              />
            </div>
            {stateLoading ? (
              <>
                <AutoCompleteForm
                  label={"State*"}
                  id={"dummystate"}
                  options={[]}
                  control={control}
                />
              </>
            ) : (
              <AutoCompleteForm
                label={"State*"}
                id={"state"}
                options={!stateLoading ? stateLists ?? [] : []}
                control={control}
                defaultValue={previousData?.state}
                handleChange={(e: any, seletedOption: any) => {
                  setValue("stateId", seletedOption?.value);
                  stateChange();
                }}
              />
            )}

            <div className="hidden w-0 h-0 invisible">
              <InputForm
                label={"District Id"}
                id="districtId"
                control={control}
                defaultValue={previousData?.districtId}
              />
            </div>
            {districtLoading ? (
              <>
                <AutoCompleteForm
                  label={"District*"}
                  id={"dummydistrict"}
                  options={[]}
                  control={control}
                />
              </>
            ) : (
              <AutoCompleteForm
                label={"District*"}
                id={"district"}
                options={!districtLoading ? districtLists ?? [] : []}
                control={control}
                defaultValue={previousData?.district}
                handleChange={(e: any, seletedOption: any) => {
                  setValue("districtId", seletedOption?.value);
                  districtChange();
                }}
              />
            )}

            <div className="hidden w-0 h-0 invisible">
              <InputForm
                label={"Taluk Id"}
                id="talukId"
                control={control}
                defaultValue={previousData?.talukId}
              />
            </div>
            {talukLoading ? (
              <>
                <AutoCompleteForm
                  label={"Taluk*"}
                  id={"dummytaluk"}
                  options={[]}
                  control={control}
                />
              </>
            ) : (
              <AutoCompleteForm
                label={"Taluk*"}
                id={"taluk"}
                options={!talukLoading ? talukLists ?? [] : []}
                control={control}
                defaultValue={previousData?.taluk}
                handleChange={(e: any, seletedOption: any) => {
                  setValue("talukId", seletedOption?.value);
                  talukChange();
                }}
              />
            )}

            <div className="hidden w-0 h-0 invisible">
              <InputForm
                label={"Hobli Id"}
                id="hobliId"
                control={control}
                defaultValue={previousData?.hobliId}
              />
            </div>
            {hobliLoading ? (
              <>
                <AutoCompleteForm
                  label={"Hobli*"}
                  id={"dummyhobli"}
                  options={[]}
                  control={control}
                />
              </>
            ) : (
              <AutoCompleteForm
                label={"Hobli*"}
                id={"hobli"}
                options={!hobliLoading ? hobliLists ?? [] : []}
                control={control}
                defaultValue={previousData?.hobli}
                handleChange={(e: any, seletedOption: any) => {
                  setValue("hobliId", seletedOption?.value);
                }}
              />
            )}
            <div className="hidden w-0 h-0 invisible">
              <InputForm
                label={"City Id"}
                id="cityId"
                control={control}
                defaultValue={previousData?.cityId}
                required={false}
              />
            </div>
            <InputForm
              label={"Town*"}
              id={"city"}
              control={control}
              defaultValue={previousData?.city}
              maxLength={50}
            />

            <InputForm
              label="Pincode*"
              id="pincode"
              type="number"
              control={control}
              defaultValue={previousData?.pincode ?? ""} // 👈 key change
              applyNumberValidation={true}
              maxLength={50}
            />

          </div>
        </div>

        <hr className="my-6" />

        <div>
          <span className="text-16 text-primary font-semibold">
            {addHospitalName.ContactDetails}
          </span>
          <Box>
            {/* Responsive Grid Container */}
            <div className="grid lg:grid-cols-2 md:grid-cols-1 gap-6 mt-6">

              {/* Field 1: Always Visible */}
              <PhoneNumLanInputForm
                setValue={setValue}
                label={"Phone"}
                id="mobileNumber"
                control={control}
                defaultValue={previousData?.mobileNumber}
              />

              {/* Field 2: Conditional */}
              {visibleFieldsCount >= 2 && (
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1, width: "100%" }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <PhoneNumLanInputForm
                      setValue={setValue}
                      label={"Alternative Phone 1"}
                      id="phoneTwo"
                      control={control}
                      defaultValue={previousData?.phoneTwo}
                    />
                  </Box>
                  {/* Remove button only visible if it's currently the last field */}
                  {visibleFieldsCount === 2 && (
                    <Button2
                      onClick={() => handleRemoveField("phoneTwo")}
                      color="error"
                      sx={{ mt: "14px", p: 1, minWidth: "auto" }}
                    >
                      <DeleteIcons />
                    </Button2>
                  )}
                </Box>
              )}

              {/* Field 3: Conditional */}
              {visibleFieldsCount === 3 && (
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1, width: "100%" }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <PhoneNumLanInputForm
                      setValue={setValue}
                      label={"Alternative Phone 2"}
                      id="phoneThree"
                      control={control}
                      defaultValue={previousData?.phoneThree}
                    />
                  </Box>
                  <Button2
                    onClick={() => handleRemoveField("phoneThree")}
                    color="error"
                    sx={{ mt: "14px", p: 1, minWidth: "auto" }}
                  >
                    <DeleteIcons />
                  </Button2>
                </Box>
              )}
            </div>

            {/* Add Button Action Layout */}
            {visibleFieldsCount < 3 && (
              <Button2
                startIcon={<AddIcon />}
                onClick={handleAddField}
                variant="text"
                sx={{
                  mt: 2,
                  fontWeight: 600,
                  color: "#1565C0",
                  "&:hover": { background: "rgba(21, 101, 192, 0.04)" },
                }}
              >
                Add Alternative Number
              </Button2>
            )}
          </Box>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-6 mt-6">

            <EmailInputForm
              label={"Email ID*"}
              id="emailID"
              control={control}
              defaultValue={previousData?.emailID}
              maxLength={50}
            />
            <InputForm
              label={"URL/ Website Name"}
              id="url"
              control={control}
              defaultValue={previousData?.url}
              maxLength={255}
              required={false}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicInformation;
